import React from "react";
import { Button, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface ScheduleCallButtonProps {
  label?: string;
  // ghlUrl?: string;
}

const ScheduleCallButton: React.FC<ScheduleCallButtonProps> = ({
  label,
  // ghlUrl,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  // const handleRedirect = () => {
  //   window.open(ghlUrl, "_blank");
  // };
  const handleRedirect = () => {
    navigate("/schedule"); // ruta interna de tu web
  };

  return (
    <>
      <Button
        onClick={handleRedirect}
        variant="contained"
        sx={{
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
        }}
      >
        {label}
      </Button>
    </>
  );
};

export default ScheduleCallButton;
